import { createFileRoute } from '@tanstack/react-router';

import { requireGuest } from '@/app/lib/auth-guard';
import { AcceptInvitePage } from '@/auth/pages/accept-invite';

export const Route = createFileRoute('/accept-invite')({
  beforeLoad: () => {
    requireGuest();
  },
  component: AcceptInviteRoute,
  validateSearch: (search) => {
    // Define a schema to validate and type your search params.
    // For example, using Zod:
    // import { z } from 'zod';
    // return z.object({
    //   query: z.string().optional(),
    //   page: z.number().default(1),
    // }).parse(search);
    return {
      email: search.email,
      inviteCode: search['invite-code']
    } as { email?: string; inviteCode?: string };
    // TODO: support &invite-code= more easily/reusably
  }
});

function AcceptInviteRoute() {
  const { email, inviteCode } = Route.useSearch();

  return <AcceptInvitePage email={email} inviteCode={inviteCode} />;
}
